import React, { useState } from 'react';
import { TIPO_LABELS } from '../data/orientaciones';
import OrientacionPanel from '../components/OrientacionPanel';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

function estadoChip(e) {
  const m = { Recibido:'chip chip-blue','En proceso':'chip chip-amber',Orientado:'chip chip-green',Cerrado:'chip chip-gray' };
  return <span className={m[e]||'chip chip-gray'}>{e}</span>;
}

export default function DetalleCaso({ caso, onBack, onAbrirSeguimiento, onEditar, userRole, onEliminar, onUpdateCaso }) {
  const [confirmEliminar, setConfirmEliminar] = useState(false);
  if (!caso) return null;
  const fmt = d => d ? format(parseISO(d), "dd 'de' MMMM yyyy", { locale: es }) : '—';

  return (
    <div>
      <div style={{ marginBottom:14, display:'flex', gap:10, alignItems:'center', flexWrap:'wrap' }}>
        <button className="btn btn-sm" onClick={onBack}>← Volver</button>
        <span className="chip-tipo">{TIPO_LABELS[caso.tipo]||caso.tipo}</span>
        {estadoChip(caso.estado)}
        <div style={{ marginLeft:'auto', display:'flex', gap:8 }}>
          {userRole === 'admin' && (
            confirmEliminar ? (
              <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                <span style={{ fontSize:12, color:'#b91c1c', fontWeight:600 }}>¿Eliminar este caso?</span>
                <button className="btn btn-sm" onClick={()=>onEliminar(caso.id)} style={{ background:'#CE1126', color:'#fff', border:'none' }}>Sí, eliminar</button>
                <button className="btn btn-sm" onClick={()=>setConfirmEliminar(false)}>Cancelar</button>
              </div>
            ) : (
              <button className="btn btn-sm" onClick={()=>setConfirmEliminar(true)} style={{ background:'#fff0f0', color:'#CE1126', border:'1px solid #fca5a5' }}>🗑 Eliminar</button>
            )
          )}
          {userRole !== 'secretaria' && (
            <button className="btn btn-sm" onClick={()=>onEditar(caso)} style={{ background:'linear-gradient(135deg,#b57a00,#F5A623)', color:'#fff', border:'none', display:'flex', alignItems:'center', gap:5 }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>
              Editar caso
            </button>
          )}
          <button className="btn btn-sm btn-primary" onClick={()=>onAbrirSeguimiento(caso)}>+ Agregar seguimiento</button>
        </div>
      </div>

      <div className="card" style={{ marginBottom:16 }}>
        <div className="card-header" style={{ background:'linear-gradient(90deg,rgba(0,45,98,.04),transparent)' }}>
          <h3>{caso.centro}</h3>
          {caso.codigoCentro&&caso.codigoCentro!=='NUEVO'&&<span style={{background:'linear-gradient(135deg,#002D62,#0a3d80)',color:'#fff',fontSize:11,fontWeight:700,padding:'2px 10px',borderRadius:20}}>{caso.codigoCentro}</span>}
        </div>
        <div className="card-body">
          <div className="detail-grid">
            <div className="detail-field"><div className="detail-label">Solicitante</div><div className="detail-value">{caso.solicitante}</div></div>
            <div className="detail-field"><div className="detail-label">Rol</div><div className="detail-value">{caso.rol||'—'}</div></div>
            <div className="detail-field"><div className="detail-label">Teléfono</div><div className="detail-value">{caso.telefono||'—'}</div></div>
            <div className="detail-field"><div className="detail-label">Correo</div><div className="detail-value">{caso.email||'—'}</div></div>
            <div className="detail-field"><div className="detail-label">Fecha del caso</div><div className="detail-value">{fmt(caso.fecha)}</div></div>
            <div className="detail-field"><div className="detail-label">Fecha límite</div><div className="detail-value">{caso.fechaAlerta?fmt(caso.fechaAlerta):'Sin fecha límite'}</div></div>
            <div className="detail-field" style={{ gridColumn:'1/-1' }}>
              <div className="detail-label">Enviado / Remitido a</div>
              <div className="detail-value">{caso.destinatario?<span className="destinatario-tag">→ {caso.destinatario}</span>:'Sin asignar'}</div>
            </div>
          </div>
          {caso.descripcion && <div style={{ background:'var(--gray-50)', borderRadius:8, padding:'12px 14px', fontSize:13, color:'var(--gray-700)', marginTop:12, lineHeight:1.6 }}>{caso.descripcion}</div>}
        </div>
      </div>

      <div className="card" style={{ marginBottom:16 }}>
        <div className="card-header"><h3>Orientación — {TIPO_LABELS[caso.tipo]||caso.tipo}</h3></div>
        <div className="card-body"><OrientacionPanel tipo={caso.tipo}/></div>
      </div>

      <div className="card">
        <div className="card-header">
          <h3>Historial de seguimiento</h3>
          <span style={{ fontSize:12, color:'var(--gray-400)' }}>{(caso.seguimientos||[]).length} entrada(s)</span>
        </div>
        <div style={{ padding:'8px 0' }}>
          {(!caso.seguimientos||caso.seguimientos.length===0) ? (
            <div style={{ padding:'24px', textAlign:'center', color:'var(--gray-400)', fontSize:13 }}>Sin seguimientos registrados.</div>
          ) : [...caso.seguimientos].reverse().map((s,i) => (
            <div key={i} style={{ display:'flex', gap:12, padding:'12px 18px', borderBottom:'1px solid var(--gray-100)' }}>
              <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:4 }}>
                <div style={{ width:10, height:10, borderRadius:'50%', background:'var(--minerd-blue)', flexShrink:0 }}/>
                {i<caso.seguimientos.length-1&&<div style={{ width:2, flex:1, background:'var(--gray-200)', minHeight:20 }}/>}
              </div>
              <div style={{ flex:1, paddingBottom:8 }}>
                <div style={{ fontSize:11, color:'var(--gray-400)', marginBottom:4 }}>{s.fecha}</div>
                <div style={{ fontSize:13, color:'var(--gray-900)', lineHeight:1.5 }}>{s.nota}</div>
                {s.destinatario&&<div style={{ marginTop:6 }}><span className="destinatario-tag">→ {s.destinatario}</span></div>}
                {s.estado&&<span className={`chip ${s.estado==='Recibido'?'chip-blue':s.estado==='En proceso'?'chip-amber':s.estado==='Orientado'?'chip-green':'chip-gray'}`} style={{ marginTop:6, display:'inline-flex' }}>{s.estado}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
